import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxLedger from '../util/remote/ajaxLedger';

const initialState = { 
    JournalList: null,
    currentPage: 1,
    metaData: null,
    mounted: false,
    dateRange: { opening_date: "", closing_date: "" },
    fetchedPeriod: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'CLEAR':
      return { initialState};  // Reset state completely
    default:
      return {...state, [action.type]: action.payload};
  }
};



const JournalContext = createContext();

export const JournalProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

   useEffect(()=>{
      if(state.mounted){
        getTransactions(true);
      }
    }, [state.currentPage]);

  
  const getTransactions = async(refresh = false, period = null)=>{
     dispatch({ type: 'mounted', payload: true });
    if(!refresh && Array.isArray(state.JournalList)){
      return;
    }
    dispatch({ type: 'JournalList', payload: null });
    const server_response = await ajaxLedger.fetchJournalEntries({
      page: period ? 1 : state.currentPage,
      opening_date: period?.opening_date || state.dateRange?.opening_date,
      closing_date: period?.closing_date || state.dateRange?.closing_date
    });
    if(server_response.status==="OK"){
      dispatch({ type: 'JournalList', payload: server_response.details.data });
      dispatch({ type: 'metaData', payload: server_response.details.meta });
      dispatch({ type: 'fetchedPeriod', payload: server_response.details.period });

    }else{
      dispatch({ type: 'JournalList', payload: "404" });
    }
  }

  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }

  const refresh = async() =>{
    await  getTransactions(true);
  }


  return(
    <JournalContext.Provider value={{
      ...state, 
      dispatch, 
      getTransactions,
      setCurrentPage,
      refresh
      }}>
      {children}
    </JournalContext.Provider>
  )

}

export const useJournal = ()=>useContext(JournalContext);

